/* global window:true */
import iframeBridge from '../utils/iframe-bridge';
import templateUtils from '../utils/template-utils';
import * as mobileAppHandler from '../utils/mobile-app';

export default class ViewManager {

  /**
   * Initialises the ViewManager instance
   *
   * @param {HTMLNode} rootElement The component
   * @return {Object|Boolean}
   */
  constructor(rootElement) {
    if (!rootElement) {
      return false;
    }

    this.config = {
      root: rootElement,
      target: null,
      template: null,
      templates: {},
      roles: [],
      status: 'default'
    };

    this.config.target = rootElement.querySelector('[data-role=view-manager-target]');
    this.config.templates = templateUtils.getTemplates(this.config);

    // if the mobile app bridge is present, then default
    // to the role-based views rather than using a roadblock
    if (mobileAppHandler.isEnabled(rootElement)) {
      this.setLoginStatus(false, mobileAppHandler.getAppRoles(this.config.templates));
    }

    this.updateView();
    return this;
  }

  /**
   * Sets the status and roles to the ViewManager instance
   * based on if the user is logged in or not
   *
   * @param {Boolean} loggedIn True when the user is logged in
   * @param {Array} roles The roles for the current user
   * @return {Object}
   */
  setLoginStatus(loggedIn, roles) {
    this.config.status = loggedIn ? 'loggedin' : 'default';
    this.config.roles = roles || [];
    return this;
  }

  /**
   * Updates the view template with the data following a role change
   *
   * @param {Object} data The data to set to the view template
   * @return {Object}
   */
  updateView(data) {
    const template = templateUtils.getTemplate(this.config);
    if (template === this.config.template) {
      return this;
    }

    const component = templateUtils.replaceVariables(template, data);
    this.config.template = template;
    this.config.target.innerHTML = component;

    if (iframeBridge.active(window)) {
      iframeBridge.updateSize(window);
    }
    return this;
  }
}
